<template>
	<div>
		<buttonlist
				@help="help"
			@opentable="opentable"
			@add="add"
			@search="search"
			@reflash="reflash"
			@exps="exps"
			@save="save"
			ref="SetBtn"
		></buttonlist>
		<el-tabs :tab-position="'top'" type="">
			<el-tab-pane :label="$t('getapi[945]')" name="0">
				<wTable
						id="xpane-0"
						:data="dataSet"
						:loading="loading"
						queryData="InvCountLineViewInfo"
						:filter_language="['Line_status']"
						:filter_thousandth="['prior_qty','Assist_Prior_Qty','prior_actually_qty','Assist_Prior_Actually_Qty','again_actually_qty',
						'Assist_Again_Actually_Qty','diff_qty','Assist_Diff_Qty']"
						:header="tableHeader"
						:option="tableOption"
						ref="singleTable"
						:checkflg="false"
				></wTable>
				<!--<el-table
					:data="dataSet"
					v-loading="loading"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					header-row-class-name="headerclass"
					style="width: 100%; margin-top:0px"
				>
					<el-table-column type="selection" v-if="false"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Order_No" :label="$t('getapi[2315]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="line_No" align="right" :label="$t('getapi[1425]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="count_type" :label="$t('getapi[2316]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Line_status" :label="$t('getapi[2325]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1957]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="prior_qty" align="right" :label="$t('getapi[2327]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Assist_Prior_Qty" align="right" :label="$t('getapi[2328]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="prior_actually_qty" align="right" :label="$t('getapi[2329]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Assist_Prior_Actually_Qty" align="right" :label="$t('getapi[2330]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="again_actually_qty" align="right" :label="$t('getapi[2331]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Assist_Again_Actually_Qty" align="right" :label="$t('getapi[2332]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="diff_qty" align="right" :label="$t('getapi[2333]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Assist_Diff_Qty" align="right" :label="$t('getapi[2334]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="batch_No"  align="right" :label="$t('getapi[1763]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="sequence_No" align="right" :label="$t('getapi[1764]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="MeasureUnit" :label="$t('getapi[888]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Assist_MeasureUnit" :label="$t('getapi[130]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="prior_count_time" :label="$t('getapi[2317]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="prior_count_person" :label="$t('getapi[2318]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="again_count_time" :label="$t('getapi[2319]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="again_count_person" :label="$t('getapi[2320]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Keep_Person" :label="$t('getapi[1864]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Regist_Person" :label="$t('getapi[1747]')"></el-table-column>
				</el-table>-->
			</el-tab-pane>
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		</el-tabs>
		<serce :isVisible="isVisible" queryData="InvCountLineViewInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[2324]')" queryData="InvCountLineViewInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
		<!-- 详情页面 -->
		<purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'InvCheckDetailView',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight2
        }
    },
	data() {
		return {
            tableHeader: [],
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('InvCheckDetailView'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			reduceTableHeight: Common.reduceTableHeight2,
			isShowEdit: false, // 是否显示编辑页面
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('InvCountLineViewInfo', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[2324]"),this.$t("getapi[15]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 82, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 82, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('InvCheckDetailView',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'InvCountLineViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost('/Inv/Check/DataList_Detail', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = (
				new Date().getFullYear() +
				'-' +
				(new Date().getMonth() + 1) +
				'-' +
				new Date().getDate() +
				' ' +
				new Date().getHours() +
				':' +
				new Date().getMinutes() +
				':' +
				new Date().getSeconds()
			).toString();
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
			
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			/*let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Inv/Check/ExportToExecl_Detail', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "InvCountLineViewInfo",
                fromname: that.$t('getapi[2324]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
